import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/svg/close_black.svg'


const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-0 left-0 right-0 bg-[var(--bg-color)] w-full mx-auto border-t z-50"
}
const _hoisted_2 = { class: "flex flex-col px-10 py-8 w-full" }
const _hoisted_3 = { class: "flex flex-col l:flex-row l:items-center l:gap-x-10 gap-y-5" }
const _hoisted_4 = { class: "flex items-center gap-x-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { ref } from 'vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import { useCookies } from '@vueuse/integrations/useCookies';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieAgreement',
  setup(__props) {

const cookies = useCookies(['agreement']);
const show = ref<boolean>(true);

const { t } = useI18n();

const onLoad = () => {
    const agreement = cookies.get('agreement');

    if (!agreement) {
        show.value = true;
        return;
    }

    show.value = false;
    return;
};

const acceptAgreement = () => {
    cookies.set('agreement', '1');
    show.value = false;
};

onLoad();

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "border border-[var(--secondary-color)] rounded-[100px] text-center cursor-pointer px-6 py-2 w-full",
                onClick: acceptAgreement
              }, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('cookie.button'),
                  type: "caption",
                  color: "var(--secondary-color)"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("div", {
                class: "cursor-pointer l:absolute l:top-[50%] l:translate-y-[-50%] l:right-6",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = false))
              }, _hoisted_6)
            ]),
            _createElementVNode("div", null, [
              _createVNode(BaseTypography, {
                text: _unref(t)('cookie.text.first'),
                type: "caption",
                tag: "span"
              }, null, 8, ["text"]),
              _createVNode(BaseTypography, {
                text: "cookie ",
                type: "caption",
                tag: "span",
                color: "var(--secondary-color)"
              }),
              _createVNode(BaseTypography, {
                text: _unref(t)('cookie.text.second'),
                type: "caption",
                tag: "span"
              }, null, 8, ["text"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})